export function getLink(path: string) {
  const pathname = window.location.pathname;
  if (pathname === path) return pathname;
  return path;
}
